module.exports = __webpack_public_path__ + "img/orderDetails-main-img.9f3276fb.png";